module.exports = [
	{
		"id": "27492000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27492000/640/27492000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Douche de tête 1 jet",
		"textblock_1st_text": "27492000",
		"textblock_2nd_text": "Douche de tête GROHE Euphoria Cosmopolitan 180",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27492000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Coude à encastrer 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28576000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28576000/640/28576000.jpg",
		"headline": "Rainshower",
		"subheadline": "Bras de douche 286 mm",
		"textblock_1st_text": "28576000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/28576000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27699000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27699000/640/27699000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Douche à main, 1 jet",
		"textblock_1st_text": "27699000",
		"textblock_2nd_text": "GROHE Euphoria Cube Stick, douchette, 1 jet",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27699000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Système de douche avec mitigeur thermostatique",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower SmartControl 360 DUO avec thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl Mono 360",
		"subheadline": "Système de douche avec mitigeur thermostatique",
		"textblock_1st_text": "26361000",
		"textblock_2nd_text": "Système de douche avec thermostat GROHE Rainshower SmartControl 360 MONO",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Combi système de douche avec thermostat, montage mural/encastré",
		"textblock_1st_text": "26443000",
		"textblock_2nd_text": "Système combi douche avec thermostat GROHE Rainshower SmartControl 360 DUO. Chromé, écologique et fabriqué en Allemagne : douche de tête 360 mm avec jet GROHE TrioMassage et douchette manuelle 115 mm avec deux jets.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl Mono 360",
		"subheadline": "Système de douche avec mitigeur thermostatique",
		"textblock_1st_text": "26361LS0",
		"textblock_2nd_text": "Système de douche exposé GROHE Rainshower SmartControl 360 MONO avec thermostatique. Chromée, écologique et fabriquée en Allemagne : Douche de tête de 360 mm (plaque de jet blanche) et douchette de 115 mm avec quatre jets.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Combi système de douche avec thermostat, montage mural/encastré",
		"textblock_1st_text": "26443LS0",
		"textblock_2nd_text": "Système de douche GROHE Rainshower SmartControl 360 Duo Combi avec thermostatique. Chromée, écologique et fabriquée en Allemagne : Douche de tête de 360 mm (plaque de jet blanche) avec jet GROHE TrioMassage et douchette de 115 mm avec deux jets.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Système de douche avec mitigeur thermostatique",
		"textblock_1st_text": "26250LS0",
		"textblock_2nd_text": "Système de douche exposé GROHE Rainshower SmartControl 360 DUO avec thermostatique. Douche de tête de 360 mm (plaque de jet blanche) chromée, écologique et fabriquée en Allemagne, avec jet GROHE TrioMassage et douchette de 115 mm avec deux jets.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - Mitigeur bec U",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en U, finition chromée.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - Mitigeur bec U",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en U, aspect acier inoxydable.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - mitigeur bec L",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en L, aspect acier inoxydable.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - mitigeur bec L",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en L, finition chromée.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - mitigeur bec C",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en C, aspect acier inoxydable.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - Mono",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Mono : robinet sur colonnette fournissant une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en C, aspect acier inoxydable.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - Mono",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Mono : un robinet dédié pour disposer d\\'eau filtrée, réfrigérée et pétillante. Comprend l\\'unité réfrigérante, le filtre et la bouteille de CO2. Bec haut en C, finition chromée.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - mitigeur bec C",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en C, finition chromée.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Robinet et chauffe-eau taille L",
		"textblock_1st_text": "30079001",
		"textblock_2nd_text": "Robinet de cuisine GROHE RED Duo (bec en C) avec filtre et chauffe-eau de taille L pour de l\\'eau bouillante instantanée. Finition chromée. Efficacité énergétique de classe A et fonctionnalités de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Robinet + Chauffe-eau taille M",
		"textblock_1st_text": "30083001",
		"textblock_2nd_text": "Robinet de cuisine GROHE RED Duo (bec en C) avec filtre et chauffe-eau de taille M pour de l\\'eau bouillante instantanée. Finition chromée. Efficacité énergétique de classe A et fonctionnalités de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Robinet + Chauffe-eau taille M",
		"textblock_1st_text": "30083DC1",
		"textblock_2nd_text": "Robinet de cuisine GROHE RED Duo (bec en C) avec filtre et chauffe-eau de taille M pour de l\\'eau bouillante instantanée. Look acier inoxydable mat. Efficacité énergétique de classe A et fonctionnalités de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Robinetterie Mono et boiler taille M",
		"textblock_1st_text": "30085001",
		"textblock_2nd_text": "Robinet de cuisine GROHE RED Mono (bec en C) avec filtre et chauffe-eau de taille M pour de l\\'eau bouillante instantanée. Finition chromée. Efficacité énergétique de classe A et fonctionnalités de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Robinetterie Mono et boiler taille L",
		"textblock_1st_text": "30080001",
		"textblock_2nd_text": "Robinet de cuisine GROHE RED Mono (bec en C) avec filtre et chauffe-eau de taille L pour de l\\'eau bouillante instantanée. Finition chromée. Efficacité énergétique de classe A et fonctionnalités de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Robinet + Chauffe-eau taille M",
		"textblock_1st_text": "30327DC1",
		"textblock_2nd_text": "Robinet de cuisine GROHE RED Duo (bec en L) avec filtre et chauffe-eau de taille M pour de l\\'eau bouillante instantanée. Look acier inoxydable mat. Efficacité énergétique de classe A et fonctionnalités de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Robinet et chauffe-eau taille L",
		"textblock_1st_text": "30325001",
		"textblock_2nd_text": "Robinet de cuisine GROHE RED Duo (bec en L) avec filtre et chauffe-eau de taille L pour de l\\'eau bouillante instantanée. Finition chromée. Efficacité énergétique de classe A et fonctionnalités de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Robinet et chauffe-eau taille L",
		"textblock_1st_text": "30079DC1",
		"textblock_2nd_text": "Robinet de cuisine GROHE RED Duo (bec en C) avec filtre et chauffe-eau de taille L pour de l\\'eau bouillante instantanée. Look acier inoxydable mat. Efficacité énergétique de classe A et fonctionnalités de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Robinet + Chauffe-eau taille M",
		"textblock_1st_text": "30327001",
		"textblock_2nd_text": "Robinet de cuisine GROHE RED Duo (bec en L) avec filtre et chauffe-eau de taille M pour de l\\'eau bouillante instantanée. Finition chromée. Efficacité énergétique de classe A et fonctionnalités de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Robinet et chauffe-eau taille L",
		"textblock_1st_text": "30325DC1",
		"textblock_2nd_text": "Robinet de cuisine GROHE RED Duo (bec en L) avec filtre et chauffe-eau de taille L pour de l\\'eau bouillante instantanée. Finition acier inoxydable mat. Efficacité énergétique de classe A et fonctionnalités de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Mitigeur pour GROHE RED",
		"textblock_1st_text": "40841001",
		"textblock_2nd_text": "Mitigeur pour GROHE RED",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/water_products_fr_be.json
// module id = 880
// module chunks = 0